/* eslint-disable */

import addNewCategory from '@/components/private/add-category-info-popup/';
import { bus } from '@/main';
import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
import removeCategoryPopup from '@/components/private/delete-category-info-popup/';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'course-categories',
  components: {
    draggable,
    'add-new-category-popup': addNewCategory,
    'remove-category-popup' : removeCategoryPopup
  },
  props: [],
  data() {
    return {
      addNewCategoryPopupState: false,
      categoryUpdateform: false,
      categoryList: null,
      submitted: false,
      deletecategoryId: '',
      categoryUpdateformId: '',
      selectImage: '',
      selectBgImage: '',
      filename: null,
      previewImgModal: false,
      previewBgImgModal: false,
      updateImage: '',
      updateBgImage: '',
      uploadingLoader: false,
      categorySortList: [],
      removeCategoryPopupState:false
    }
  },
  computed: {
    ...mapGetters([
      'getCategoriesListGetters',
      'getcategoryDetailsByIdDataState'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    getCategoryMethod() {
      this.categoryList = this.$store.getters.getCategoriesListGetters.data;
      return;
    },
    setInitialStatesMethod() {
      if (this.categoryList) {
        this.categorySortList = this.categoryList.data
      }
      return;
    }
  },
  mounted() {
    this.getCategoryMethod;
    this.setInitialStatesMethod;
    bus.$on('addNewCategoryPopupStateBus', (data) => {
      this.addNewCategoryPopupState = data;
    });
    bus.$on('removeCategoryPopupStateBus', (data) => {
      this.removeCategoryPopupState = data;
    });
  },
  methods: {
    getCategoryAgain() {
      this.$store.dispatch('getCategoriesListAction');
    },
    addNewCategoryMethod() {
      this.addNewCategoryPopupState = true;
    },
    deleteCategoryMethod(id) {
      this.deletecategoryId = id;
      this.removeCategoryPopupState = true;
    },
    updateCategoryFun(id) {
      this.categoryUpdateformId = id;
      this.categoryUpdateform = true;
      if (this.categoryUpdateform == true) {
        let data = {
          id: this.categoryUpdateformId
        }
        this.$store.dispatch('getCategoryDetailsById', data)
          .then((res) => {
            if (res.status == '200' || res.status == '202') {
              this.name = this.$store.getters.getcategoryDetailsByIdDataState.data.name
              this.description = this.$store.getters.getcategoryDetailsByIdDataState.data.description
              this.selectImage = this.$store.getters.getcategoryDetailsByIdDataState.data.image
              this.selectBgImage = this.$store.getters.getcategoryDetailsByIdDataState.data.bg_image
            }
          });
      }
    },
    updatehandleImageUpload(event) {
      this.updateImage = event.target.files[0];
      this.updateImages = this.$refs.image.files[0];
      let formData = new FormData();
      if (this.updateImages) {
        formData.append('image', this.updateImages);
      }
      this.$store.dispatch('updateCategoryListById', {
        data: {
          formdata: formData,
          id: this.categoryUpdateformId
        }
      })
        .then((res) => {
          if (res.status == '200') {
            this.selectImage = res.data.data.image;
            this.getCategoryAgain();
          }
        })
        .catch((err) => { })
      return
    },
    updatehandleBgImageUpload(event) {
      this.updateBgImage = event.target.files[0];
      this.updateBgImages = this.$refs.bg_image.files[0];
      let formData = new FormData();
      if (this.updateBgImages) {
        formData.append('bg_image', this.updateBgImages);
      }
      this.$store.dispatch('updateCategoryListById', {
        data: {
          formdata: formData,
          id: this.categoryUpdateformId
        }
      })
        .then((res) => {
          if (res.status == '200') {
            this.selectBgImage = res.data.data.bg_image
            this.getCategoryAgain();
          }
        })
        .catch((err) => { })
      return
    },
    previewImgFun() {
      this.previewImgModal = true
    },
    previewBgImgFun() {
      this.previewBgImgModal = true
    },
    categorySort(event) {
      if (event.moved && event.moved != undefined) {
        this.updateRowIndex(event.moved.element.id, Number(event.moved.newIndex) + 1);
      }
    },
    updateRowIndex(categoryId, rowIndex) {
      let data = {
        index: rowIndex
      }
      this.$store.dispatch('UpdateCategoryIndex', {
        data: {
          data: data,
          id: categoryId
        }
      })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCategoryAgain();
        })
        .catch((err) => { })
    }
  },
  watch: {
    getCategoryMethod() {
      return this.$store.getters.getCategoriesListGetters
    },
    setInitialStatesMethod() {
      if (this.categoryList) {
        this.categorySortList = this.categoryList.data
      }
      return;
    }
  }
}